import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { FaArrowRight } from "react-icons/fa";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";

const EnrollPopup = ({ onClose }) => {
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    message: "",
  };

  const handleSubmit = (values, { resetForm }) => {
    setIsLoading(true);

    // EmailJS send
    emailjs
      .send(
        "service_rcn70tr",
        "template_m62k5b5",
        values,
        "H40tlS4xZmTXzFhz4"
      )
      .then(
        (result) => {
          toast.success(
            "Thank you! Our admissions team will contact you soon."
          );
          resetForm();
          onClose(); // close popup after submission
        },
        (error) => {
          toast.error("Oops! Something went wrong. Please try again.");
        }
      )
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl p-6 max-w-4xl w-full relative shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-pink-600 text-2xl font-bold"
        >
          &times;
        </button>
        <h2 className="text-2xl font-bold mb-4 text-center">Enroll Now</h2>
        <p className="text-center mb-6">
          Fill in your details and our team will contact you shortly.
        </p>

        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {() => (
            <Form className="space-y-4 text-start">
              <div>
                <label className="block mb-1 font-semibold">Name *</label>
                <Field
                  type="text"
                  name="name"
                  required
                  className="w-full border px-4 py-2 rounded bg-gray-100"
                />
              </div>
              <div>
                <label className="block mb-1 font-semibold">Email *</label>
                <Field
                  type="email"
                  name="email"
                  required
                  className="w-full border px-4 py-2 rounded bg-gray-100"
                />
              </div>
              <div>
                <label className="block mb-1 font-semibold">Phone</label>
                <Field
                  type="text"
                  name="phone"
                  className="w-full border px-4 py-2 rounded bg-gray-100"
                />
              </div>
              <div>
                <label className="block mb-1 font-semibold">Message</label>
                <Field
                  as="textarea"
                  name="message"
                  rows="4"
                  className="w-full border px-4 py-2 rounded bg-gray-100"
                />
              </div>

              <div className="mt-4 flex justify-start">
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white font-bold py-2 px-6 rounded-full flex items-center justify-center gap-2 ${
                    isLoading ? "opacity-60 cursor-not-allowed" : ""
                  }`}
                >
                  {isLoading ? (
                    "Submitting..."
                  ) : (
                    <>
                      Enroll <FaArrowRight className="ml-2" />
                    </>
                  )}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default EnrollPopup;
